import React from "react";
import { connect } from "react-redux";
import { Logo } from "../profile/logo";
import { FullName } from "../profile/full-name";
import { ModalFooter, Submit } from "../../../react-components/modals/modal-form-elements";
import {
  ProfileImage,
  OnBoardingInvestorAction,
  ProfileModuleState,
  EditProfilePayload,
  EditProfileAction,
} from "../redux/profile/types";
import { onBoardingInvestor, editProfile } from "../redux/profile/actions";
import { AppState } from "../../../redux";
import { InvestorType } from "../profile/investor-types";
import { AccreditedInvestorType } from "../profile/accredited-investor-types";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import isEmpty from "lodash.isempty";
import { AccountType } from "../../../redux/types/account-type";

interface MapStateProps {
  profileImage: ProfileImage;
  fullName: string;
  inProgress: boolean;
  user: Person;
  accountType: AccountType | null;
}

interface MapDispatchProps {
  editProfile: (payload: EditProfilePayload) => EditProfileAction;
  onBoardingInvestor: () => OnBoardingInvestorAction;
}

type Props = MapDispatchProps & MapStateProps;

const Component = (props: Props) => {
  const { accountType, fullName, inProgress, editProfile, user, onBoardingInvestor } = props;
  const title = "Create your Investor profile";

  const hasAtLeastTwoNames = /\w +\w/.test(fullName);
  const hasInvestorType = !isEmpty(accountType?.subKind) && !isEmpty(accountType?.description);
  const isValid = hasAtLeastTwoNames && hasInvestorType;

  React.useEffect(() => {
    if (!user) {
      return;
    }
    editProfile({ subject: user });
  }, [editProfile, user]);

  const onSubmit = React.useCallback(() => {
    onBoardingInvestor();
  }, [onBoardingInvestor]);

  return (
    <Container>
      <div className="subtitle">{title}</div>
      <Logo isRequired={false} />
      <FullName />
      <InvestorType />
      <AccreditedInvestorType />
      <ModalFooter>
        <Submit
          onClick={onSubmit}
          disabled={false}
          className={isValid ? `` : "disabled"}
          isSubmitting={inProgress}
          title="Continue"
        />
      </ModalFooter>
    </Container>
  );
};

const Container = ({ children }) => {
  return <div className="onboarding-investor">{children}</div>;
};

const mapState = (state: AppState & ProfileModuleState) => ({
  user: state.account.user,
  profileImage: state.profile.profileImage,
  fullName: state.profile.fullName,
  accountType: state.profile.accountType,
  inProgress: state.cache.inProgress["onboarding-investor"],
});

const mapDispatch = {
  editProfile: editProfile,
  onBoardingInvestor: onBoardingInvestor,
};

export const OnBoardingInvestor = connect(mapState, mapDispatch)(Component);
